import React from 'react';
import { Typography } from 'fronton-react';

type TProps = {
  value: string;
};

export const ColoringCode = ({ value }: TProps) => (
  <>
    <Typography color="text-primary" variant="caption">
      Арт.
    </Typography>{' '}
    <Typography color="text-minor" variant="caption">
      {value}
    </Typography>
  </>
);
